import { toClassicIcon, webmasterIcon } from "common/defaultIcons";
import useHelpers from "composables/useHelpers";
import { manageAiPromptsRouteFragment } from "manage-ai-prompts/routes/fragments";
import { npsDataRouteFragment } from "nps/routes/fragments";
import { USER_ROLES } from "shared/constants";
import { PARTNER_API_ROUTE_NAMES } from "partnerApi/routes/routeNames";

const { mappedTerms } = useHelpers();

const routes = [
  {
    path: "/webmaster",
    name: "webmasterIndex",
    redirect: {
      name: "LoginAsSchool",
    },
    meta: {
      title: "Webmaster",
      roleRequired: ["webmaster"],
      icon: toClassicIcon(webmasterIcon),
      menuSection: "manage",
      isMenuItem: true,
      isOther: true,
      menuOrder: 1,
    },
    children: [
      {
        path: "schools",
        name: "manageSchools",
        component: () => import("pages/admin/Schools.vue"),
        meta: {
          title: "Scholen beheren",
          roleRequired: ["webmaster"],
          isMenuItem: true,
          menuSection: "manage",
        },
      },
      {
        path: "login-as-school",
        name: "LoginAsSchool",
        component: () => import("pages/admin/LoginAsSchool.vue"),
        meta: {
          title: "Inloggen als school",
          roleRequired: ["webmaster"],
          isMenuItem: true,
          menuSection: "manage",
        },
      },
      {
        path: "login-as-employee",
        name: "LoginAsEmployee",
        component: () => import("pages/admin/LoginAsEmployee.vue"),
        meta: {
          title: "Inloggen als medewerker",
          roleRequired: ["webmaster"],
          isMenuItem: true,
          menuSection: "manage",
        },
      },
      {
        path: "login-as-student",
        name: "LoginAsStudent",
        component: () => import("pages/admin/LoginAsStudent.vue"),
        meta: {
          title: `Inloggen als ${mappedTerms.student} `,
          roleRequired: ["webmaster"],
          isMenuItem: true,
          menuSection: "manage",
        },
      },
      {
        path: "updates",
        name: "manageFeatures",
        component: () =>
          import("pages/manage-features/ManageFeaturesIndex.vue"),
        meta: {
          title: "Nieuwe updates",
          roleRequired: ["webmaster"],
          isMenuItem: true,
          menuSection: "manage",
        },
        children: [
          {
            path: "add",
            name: "addFeature",
            component: () => import("pages/manage-features/AddFeature.vue"),
            meta: {
              title: "Update toevoegen",
              roleRequired: ["webmaster"],
              menuSection: "manage",
            },
          },
          {
            path: "edit/:manageFeatureId",
            name: "editFeature",
            component: () => import("pages/manage-features/EditFeature.vue"),
            meta: {
              title: "Update bewerken",
              roleRequired: ["webmaster"],
              menuSection: "manage",
            },
          },
        ],
      },
      {
        path: "status-message",
        name: "StatusMessage",
        component: () => import("pages/admin/StatusMessage.vue"),
        meta: {
          title: "Statusmelding",
          roleRequired: ["webmaster"],
          isMenuItem: true,
          menuSection: "manage",
        },
      },
      {
        path: "school-stats",
        name: "SchoolStats",
        component: () => import("pages/admin/SchoolStats.vue"),
        meta: {
          title: "School Statistieken",
          roleRequired: ["webmaster"],
          isMenuItem: true,
          menuSection: "manage",
        },
      },
      npsDataRouteFragment,
      manageAiPromptsRouteFragment,
      {
        path: "tips",
        name: "Tips",
        component: () => import("pages/admin/Tips.vue"),
        meta: {
          title: "Tips",
          roleRequired: ["webmaster"],
          isMenuItem: true,
          menuSection: "manage",
        },
      },
      {
        path: "synonyms",
        name: "Vak Synoniemen",
        component: () => import("pages/admin/Synonyms.vue"),
        meta: {
          title: "Vak synoniemen",
          roleRequired: ["webmaster"],
          isMenuItem: true,
          menuSection: "manage",
        },
      },
      {
        path: "partner-api",
        name: PARTNER_API_ROUTE_NAMES.PARTNER_LIST,
        component: () => import("partnerApi/pages/WebmasterPartnerPage.vue"),
        meta: {
          title: "Partner API",
          roleRequired: [USER_ROLES.WEBMASTER],
          isMenuItem: true,
          menuSection: "manage",
        },
      },
      {
        path: "partner-api/notifications",
        name: PARTNER_API_ROUTE_NAMES.PARTNER_NOTIFICATIONS,
        component: () =>
          import("partnerApi/pages/WebmasterNotificationSettingsPage.vue"),
        meta: {
          title: "Notificaties",
          roleRequired: [USER_ROLES.WEBMASTER],
          menuSection: "manage",
        },
      },
      {
        path: "partner-api/:partnerId/tasks",
        name: PARTNER_API_ROUTE_NAMES.PARTNER_TASKS,
        component: () =>
          import("partnerApi/pages/WebmasterPartnerTasksPage.vue"),
        meta: {
          title: "Partner API",
          roleRequired: [USER_ROLES.WEBMASTER],
          menuSection: "manage",
        },
      },
      {
        path: "sync-logs",
        name: "SyncLogs",
        component: () => import("pages/admin/SyncLogs.vue"),
        meta: {
          title: "Sync logs",
          roleRequired: ["webmaster"],
          isMenuItem: true,
          menuSection: "manage",
        },
      },
      {
        path: "logs",
        name: "Logs",
        component: () => import("pages/admin/LogPage.vue"),
        meta: {
          title: "Logs",
          roleRequired: ["webmaster"],
          isMenuItem: true,
          menuSection: "manage",
        },
      },
      {
        path: "api-tester",
        name: "ApiTester",
        component: () => import("pages/admin/ApiTester.vue"),
        meta: {
          title: "API Tester",
          roleRequired: ["webmaster"],
          isMenuItem: true,
          menuSection: "manage",
          layout: "FullScreenLayout",
          allowWhenImpersonating: true,
        },
      },
      {
        path: "component-library",
        name: "ComponentLibrary",
        component: () => import("pages/admin/ComponentLibrary.vue"),
        meta: {
          title: "Component Library",
          roleRequired: ["webmaster"],
          isMenuItem: true,
          menuSection: "manage",
        },
      },
    ],
  },
];

export default routes;
